import React, { useEffect, useState } from "react";
import { Modal, message } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../../services/apiConfig";

const AddressSelect = ({ 
    setSelectedAddress, 
    selectedAddress, 
    isAddressModalOpen, 
    addressSelectHandleCancel, 
    isAddressSelectModalOpen 
}) => {
    const profileData = JSON.parse(localStorage.getItem('profile'));
    const userId = profileData?.user_id || profileData?.id || 5;

    const [addressList, setAddressList] = useState([]);
    const addressListfetch = async () => {
        if (!userId) return;
        try {
            const response = await axios.get(`${API_BASE_URL}addresses?userId=${userId}`);
            // console.log("response", response);
            if (response.data && response.data.success) {
                setAddressList(response.data.data || []);
            } else {
                message.error('Failed to fetch addresses.');
            }
        } catch (error) {
            console.error('Error fetching addresses:', error);
            message.error('Failed to fetch addresses.');
        }
    };

    useEffect(() => {
        if (isAddressSelectModalOpen || isAddressModalOpen) {
            addressListfetch();
        }
    }, [isAddressSelectModalOpen, isAddressModalOpen]);

    const handleOk = () => {
        addressSelectHandleCancel();
    };

    const handleCancel = () => {
        addressSelectHandleCancel();
    };

    const handleAddressChange = async (address) => {
        setSelectedAddress(address);
        try {
            await axios.patch(`${API_BASE_URL}addresses/${address.id}/default`, { userId }, {
                headers: { "Content-Type": "application/json" }
            });
            addressListfetch();
        } catch (err) {
            console.error("Failed to update default address:", err);
        }
    };

    return (
        <Modal
            title="Select Address"
            open={isAddressSelectModalOpen} // Ant Design v5 uses 'open' instead of 'visible'
            onOk={handleOk}
            onCancel={handleCancel}
        >
            <div className="OrderDetials-billing-personal-detailsOrderAddresscon">
                {addressList && addressList.length > 0 ? (
                    addressList.map((elem) => (
                        <div key={elem.id} className="OrderAddresscon-personal-details" style={{ marginBottom: "15px", display: "flex", gap: "10px" }}>
                            <input
                                type="radio"
                                name="selectedAddress"
                                id={"address_id_" + elem.id}
                                className="form-input-check"
                                onChange={() => handleAddressChange(elem)}
                                checked={Number(selectedAddress?.id) === Number(elem.id)}
                            />
                            <label htmlFor={"address_id_" + elem.id} style={{ cursor: "pointer" }}>
                                <strong>{elem?.full_name}</strong> ({elem?.address_type || 'Home'})<br />
                                {elem?.address_line1},<br />
                                {elem?.locality && <>{elem.locality},<br /></>}
                                {elem?.city}, {elem?.state} - {elem?.postal_code}<br />
                                Phone: {elem?.phone_dial_code || '+91'} {elem?.phone}
                            </label>
                        </div>
                    ))
                ) : (
                    <p>No saved addresses found.</p>
                )}
            </div>
        </Modal>
    );
};

export default AddressSelect;